import { render, staticRenderFns } from "./adminPam.vue?vue&type=template&id=41fb72ba&"
import script from "./adminPam.js?vue&type=script&lang=js&"
export * from "./adminPam.js?vue&type=script&lang=js&"
import style0 from "./adminPam.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports